namespace RioERP.Web.Enums {
    export enum ShippingTrackingNoStatus {
        Assigned = 1,
        Opens = 2
    }
    Serenity.Decorators.registerEnumType(ShippingTrackingNoStatus, 'RioERP.Web.Enums.ShippingTrackingNoStatus');
}
